<section>
    <div class="row">
        <div class="col-12 text-center">
            <h2 class="title">Agregar viáticos de {{name}}</h2>
        </div>
    </div>
</section>